import React from 'react';
import { IconType } from 'react-icons';

interface IconWrapperProps {
  icon: IconType;
  size?: number;
  className?: string;
}

export const IconWrapper: React.FC<IconWrapperProps> = ({ icon: IconComponent, size, className }) => {
  const Icon = IconComponent as React.ComponentType<{ size?: number; className?: string }>;
  return <Icon size={size} className={className} />;
};

